import React, { useState } from "react";
import { Button, Col, Row, Select, message } from "antd";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import vanImage from "../assets/van.png";
import defaultLogo from "../assets/efficient-logo.png";
import dubaiBg from "../assets/defalutCover.jpg";
import { SLIDE_TYPES } from "../constants/slideTypes";
import SlideEditorRenderer from "../components/SlideEditorRenderer";
import PdfDocument from "../components/PdfDocument";
import "../fonts/registerFonts";

const PdfBuilder = () => {
  const points = [
    "Arrive at Noi Bai Airport, welcomed by guide and transfer to hotel.",
    "Hanoi – A thousand years old city with exotic charm.",
    "City tour: Ho Chi Minh Mausoleum, One Pillar Pagoda, Literature Temple.",
    "Walk through Hanoi Old Quarter and enjoy shopping.",
  ];

  const hotelDetails = [
    {
      date: "02-Oct-2025",
      location: "Bentota",
      hotelName: "Pandanus Beach Resort & Spa Pandanus Beach Resort & Spa",
      starCategory: "04 Star",
      roomType: "Double",
      numRooms: 2,
      mealPlan: "HB",
      roomCategory: "Standard",
    },
  ];

  const paymentTerms = [
    {
      heading: "Booking Deposit Fees",
      description:
        "AED 1500.00 per person. Non-refundable deposit. (Upon booking confirmation)",
    },
    {
      heading: "Second Payment",
      description:
        "100% of the balance amount including extras booked. (45 days before departure or with visa submission whichever comes first)",
    },
  ];

  const cancellationPolicy = [
    "Once confirmed, booking fees of Aed 1500 will be Non-refundable.",
    "Prior to 60–45 days: 50% nonrefundable",
    "44–30 days: 75% nonrefundable",
    "Less than 29 days: 100% nonrefundable",
  ];

  const allTerms = [
    "Rates are subject to availability.",
    "Above is just a quote, no booking has been made yet.",
  ];

 
  const [slides, setSlides] = useState([
    {
      id: Date.now(),
      type: SLIDE_TYPES.COVER,
      bg: dubaiBg,
      logo: defaultLogo,
      heading: "TOUR PROPOSAL",
      subHeading: "4 Nights & 5 Days",
      highlight: "DUBAI",
      highlight2: "DELIGHT",
      date: "09 AUG - 16 AUG ‘25",
      tagline:
        "Dubai – Not just a destination, but a lifetime of memories in 5 magical days",
    },
  ]);

  const [selectedType, setSelectedType] = useState(null);
  const [shouldGenerate, setShouldGenerate] = useState(false);
  const [triggerSave, setTriggerSave] = useState(false);  

 
  const addSlide = (type) => {
    if (!type) return;
    let newSlide = { id: Date.now(), type, bg: "" };

    switch (type) {
      case SLIDE_TYPES.INCLUSIONS:
        newSlide = {
          ...newSlide,
          heading: "INCLUSIONS",
          points: [
            "Return Air ticket Turkish Airlines - Economy. (Luggage : 30kg)",
            "03 nights' accommodation in Hotel 4* or similar in Paris.",
            "03 nights' accommodation in Hotel 3* or similar in Switzerland.",
          ],
        };
        break;
      case SLIDE_TYPES.EXCLUSIONS:
        newSlide = {
          ...newSlide,
          heading: "EXCLUSIONS",
          exclusions: [
            "Personal expenses",
            "Meals not mentioned",
            "Travel insurance",
            "Visa fees",
          ],
        };
        break;
      case SLIDE_TYPES.FLIGHTS:
        newSlide = {
          ...newSlide,
          title: "FLIGHT DETAILS",
          subtitle: "Your journey awaited",
          flights: [
            {
              type: "DEPARTURE",
              time: "09:15",
              date: "29 NOV 2025",
              airline: "Air Arabia",
              city: "Abu Dhabi",
              airport: "AUH – ABU DHABI INTERNATIONAL AIRPORT",
            },
          ],
        };
        break;
      case SLIDE_TYPES.ITINERARY:
        newSlide = {
          ...newSlide,
          dayNumber: "01",
          title: "DAY BENTOTA",
          date: "02-Oct-2025",
          points,
        };
        break;
      case SLIDE_TYPES.TRANSPORT:
        newSlide = {
          ...newSlide,
          heading: "Transport Details",
          items: [
            { icon: "driver", label: "Private Driver & Guide" },
            { icon: "bus", label: "Luxury AC Bus 40-seater" },
          ],
        };
        break;
      case SLIDE_TYPES.HOTELS:
        newSlide = {
          ...newSlide,
          title: "HOTEL DETAILS",
          subtitle: "The Perfect Blend Of Luxury",
          hotelGroups: [{ groupName: "HOTEL OPTION 01", hotels: hotelDetails }],
        };
        break;
      case SLIDE_TYPES.POLICY:
        newSlide = {
          ...newSlide,
          title: "Payment TERMS & POLICY",
          policyGroups: [
            { groupName: "PAYMENT TERMS", detail: paymentTerms },
            { groupName: "CANCELLATION POLICY", detail: cancellationPolicy },
          ],
        };
        break;
      case SLIDE_TYPES.TERMS:
        newSlide = {
          ...newSlide,
          heading: "Terms & Conditions",
          allTermsGroup: [{ groupName: "All TERMS", detail: allTerms }],
        };
        break;
      case SLIDE_TYPES.THANKYOU:
        newSlide = {
          ...newSlide,
          title: "Thank you",
          subtitle:
            "Let’s Make Your Next Trip Unforgettable Plan Your Journey With Us",
          thankyouGroup: [
            {
              type: "Meet us",
              heading: "Efficient Tourism",
              address:
                "Efficient Tourism Office -201, 2nd floor, A-Block, Al Shoala Building, Port Saeed, Deira, Dubai",
            },
            {
              type: "CALL us",
              heading: "Efficient Tourism",
              phoneNumberOne: "+971 4 2238 552",
              phoneNumberTwo: "+971 4 2269 486",
            },
            {
              type: "Write us",
              heading: "Efficient Tourism",
              email: "info@efficienttourism.com",
            },
          ],
        };
        break;
      default:
        break;
    }

    setSlides((prev) => [...prev, newSlide]);
    setSelectedType(null);
  };

  const updateSlide = (id, updatedData) => {
    setSlides((prev) =>
      prev.map((slide) =>
        slide.id === id ? { ...slide, ...updatedData } : slide
      )
    );
  };

  const removeSlide = (id) => {
    setSlides((prev) => prev.filter((s) => s.id !== id));
  };

  const handleSend = () => {
    setTriggerSave((prev) => !prev);

    setTimeout(() => {
      setShouldGenerate(true);
      message.success("All changes applied — PDF updated!");
    }, 200);
  };

  return (
    <div className="p-4">
      <div className="flex gap-4 flex-col lg:flex-row">
        <Row gutter={16}>
          {/* Left Panel */}
          <Col span={6} className="topChartCard">
            <div className="max-w-sm w-full flex-shrink-0 space-y-4">
              <div className="flex gap-2 mb-4">
                <Select
                  placeholder="Select Slide Type"
                  style={{ width: 200 }}
                  value={selectedType}
                  onChange={addSlide}
                  allowClear
                  options={[
                    { label: "Cover Slide", value: SLIDE_TYPES.COVER },
                    {
                      label: "Inclusions Slide",
                      value: SLIDE_TYPES.INCLUSIONS,
                    },
                    {
                      label: "Exclusions Slide",
                      value: SLIDE_TYPES.EXCLUSIONS,
                    },
                    { label: "Flight Slide", value: SLIDE_TYPES.FLIGHTS },
                    { label: "Hotels Slide", value: SLIDE_TYPES.HOTELS },
                    { label: "Transport Slide", value: SLIDE_TYPES.TRANSPORT },
                    { label: "Itinerary Slide", value: SLIDE_TYPES.ITINERARY },
                    {
                      label: "Payment & Policy Slide",
                      value: SLIDE_TYPES.POLICY,
                    },
                    {
                      label: "Terms & Conditions Slide",
                      value: SLIDE_TYPES.TERMS,
                    },
                    { label: "Thank You Slide", value: SLIDE_TYPES.THANKYOU },
                  ]}
                />
              </div>

              {slides.map((slide) => (
                <SlideEditorRenderer
                  key={slide.id}
                  slide={slide}
                  updateSlide={updateSlide}
                  removeSlide={removeSlide}
                  triggerSave={triggerSave} 
                />
              ))}
            </div>
            {/* Send + Export */}
            <div className="flex flex-col gap-3">
              <Button
                type="primary"
                className="bg-blue-600 w-full lg:w-1/4 py-3"
                onClick={handleSend}
              >
                Send
              </Button>

              {shouldGenerate && (
                <PDFDownloadLink
                  document={<PdfDocument slides={slides} />}
                  fileName="tour-proposal.pdf"
                >
                  {({ loading }) =>
                    loading ? (
                      <Button type="primary" disabled>
                        Generating...
                      </Button>
                    ) : (
                      <Button
                        className="bg-green-600 w-full lg:w-1/4 py-3 !h-auto"
                        type="primary"
                      >
                        Export PDF
                      </Button>
                    )
                  }
                </PDFDownloadLink>
              )}
            </div>
          </Col>

          {/* Right Panel */}
          <Col span={18}>
            <div
              style={{ width: "100%", height: "100%" }}
              className="w-full border rounded-xl p-4 space-y-4"
            >
              {/* PDF Preview */}
              <div
                style={{ width: "100%", height: "100%" }}
                className="w-full h-auto lg:h-full"
              >
                <PDFViewer
                  key={shouldGenerate ? JSON.stringify(slides) : "static"} 
                  className="w-full h-auto lg:h-full rounded-lg border"
                  style={{ width: "100%", height: "100%" }}
                >
                  <PdfDocument slides={slides} />
                </PDFViewer>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PdfBuilder;
